import React from 'react'
import {CButton, CForm, CFormInput} from "@coreui/react";
import CustomPagination from "../../components/CustomPagination";
import NewBookingOrdersTable from "./NewBookingOrdersTable";
import {Link} from "react-router-dom";


const NewBookingOrders = () => {

  return (
    <div>
      <NewBookingOrdersTable />
    </div>
  );
}

export default NewBookingOrders;
